import { cerrado, esVerdadero } from './catalogo';

export function evaluarAsignacion(fila, usuario, confirmarCerrado) {
  const base = { id: fila.id, noEnvio: fila.no_envio || String(fila.id), estado: 'OMITIDO', desmarcable: true };
  if (!usuario) return { ...base, estado: 'PENDIENTE', motivo: 'Seleccione el cajero destino.', desmarcable: false };
  if (esVerdadero(fila.borrado) || !esVerdadero(fila.activado)) return { ...base, motivo: 'El envio esta inactivo o cancelado.' };
  if (!Number(usuario.sucursal) || Number(fila.codigo_sucursal_paquete || fila.sucursal) !== Number(usuario.sucursal))
    return { ...base, motivo: 'El envio y el cajero destino pertenecen a sucursales distintas.' };
  if (String(fila.cajero || '').trim() === String(usuario.valor).trim()) return { ...base, motivo: 'El envio ya pertenece a este cajero.' };
  if (cerrado(fila) && !confirmarCerrado) return { ...base, motivo: 'Requiere confirmar la correccion del cierre guardado.', desmarcable: false };
  return { ...base, estado: 'COMPATIBLE', motivo: 'Listo para asignar.', desmarcable: false };
}
